export default {
  SET_CRITERIOS(state, criterios) {
    state.criterios = criterios;
    this.commit('criterios/VALIDAR_CRITERIOS');
  },
  UPDATE_CRITERIO(state, updatedCriterio) {
    let encontrou = 0;
    state.criterios = state.criterios.map((item) => {
      if (item.sequencia == updatedCriterio.updatedCriterio.sequencia) {
        encontrou = 1;
        return updatedCriterio.updatedCriterio;
      }
      return item;
    });

    if (!encontrou) {
      state.criterios[updatedCriterio.updatedCriterio.sequencia] = updatedCriterio.updatedCriterio;
    }
    state.criterios.forEach((item, index) => {
      item.sequencia = index;
    });
    this.commit('criterios/VALIDAR_CRITERIOS');
  },
  ADD_CRITERIO(state, newCriterio) {
    if (Array.isArray(newCriterio)) {
      state.criterios = newCriterio;
    } else if (typeof newCriterio === 'object' && newCriterio !== null) {
      state.criterios.push(newCriterio);
    } else {
      console.warn('O tipo de newCriterio não é suportado:', newCriterio);
    }
    this.commit('criterios/VALIDAR_CRITERIOS');
  },
  DELETE_CRITERIO(state, criterio) {
    state.criterios = state.criterios.filter(item => {
      if (criterio.id && item.id) {
        return item.id !== criterio.id;
      }
      
      if (criterio.sequencia && item.sequencia) {
        return item.sequencia !== criterio.sequencia;
      }

      const fieldsToCompare = ['operadorLogico', 'tipoCriterio', 'operadorRelacional', 'valor'];
      const isEqual = fieldsToCompare.every(field => item[field] === criterio[field]);
      return !isEqual;
    });
    state.criterios.forEach((item, index) => {
      item.sequencia = index + 1;
    });
    this.commit('criterios/VALIDAR_CRITERIOS');
  },
  VALIDAR_CRITERIOS(state) {
    let criterios = state.criterios;
    let erros = [];
    
    criterios.forEach((criterio, index) => {
      let camposFaltantes = [];
      if (!criterio.operadorLogico) {
        camposFaltantes.push('operadorLogico');
      }
      if (!criterio.tipoCriterio) {
        camposFaltantes.push('tipoCriterio');
      }
      if (!criterio.operadorRelacional) {
        camposFaltantes.push('operadorRelacional');
      }
      
      if (criterio.tipoCriterio === "ServicoCalibracao") {
        if (!criterio.servicoCalibracao.id || !criterio.tipoCalibracaoId) {
          camposFaltantes.push('servicoCalibracao.id', 'servicoCalibracao.codigo');
        }
      }
      
      if (criterio.tipoCriterio === "TipoCalibracao") {
        if (!criterio.tipoCalibracaoId && !criterio.tipoCalibracao.id) {
          camposFaltantes.push('tipoCalibracao.id');
        }
      }

      if (camposFaltantes.length > 0) {
        erros.push({
          item: index + 1,
          mensagem: `Campos obrigatórios ausentes no critério ${index + 1}: ${camposFaltantes.join(', ')}`
        });
      }
    });

    state.erros = erros;
  },
  SET_ERRORS(state, erros) {
    state.erros = erros;
  }
}